import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { FONT_SIZES } from '@/theme'

const Tag = (props) => {
  const classes = useStyles()

  return (
    <div className={classes.tagWrapper}>
      <span className={classes.tagText} title={props.label}>{props.label}</span>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  tagWrapper: {
    backgroundColor: theme.backgroundColor,
    border: `1px solid ${theme.borderColor}`,
    marginRight: 10,
    borderRadius: 15,
    textAlign: 'center',
    height: 30,
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
    minWidth: 40,
  },
  tagText: {
    padding: 15,
    fontSize: FONT_SIZES.smaller,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))

Tag.propTypes = {
  label: PropTypes.string,
}

export default Tag
